const url = '/payment-gateway';
const Provider = 'PaymentGateway';
const dbModel = 'PaymentGateway';

export { url, Provider, dbModel };
